export const statuses = {
    pending: "Pending",
    success: "Success",
    error: "Error",
}
